import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import ProductGroupFilter from "components/filters/Filters/ProductGroupFilter";
import { getMoneyFormatter } from "utilities/formatter";
import classNames from "classnames";
import { useLoaderData } from "react-router";

const ProductTemplateList = () => {
  const viewModel = useLoaderData<server.viewmodel.ProductTemplateListFrontModel>();

  const getVatPercentageFromId = (vatId: number) => {
    return viewModel.vatRates.find(v => v.vatRateId === vatId)?.percentageFormatted;
  }

  const moneyFormatter = getMoneyFormatter();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet="productTemplate_List"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        fetchFunction={window.CoreApi.ProductTemplates.Paginated}
        getId={item => item.productTemplateId}
        onNew={() => window.location.href = routes.productTemplate_New().absolute}
        layout={{
          type: "table",
          columns: [
            { header: RESX.GeneralLabels.InternalTitle, render: item => <a href={routes.productTemplate_Detail(item.productTemplateId).absolute}>{item.title}</a>, key: "title" },
            { header: RESX.ProductTemplate.ProductType, render: item => <span className={classNames({ "s1_red": item.productType.value === "undefined" })}>{item.productType.text}</span>, key: "productType" },
            { header: RESX.ProductGroup.resxProductGroup, hidden: !site.currentEnvironment.hasProductGroups, render: item => item.productGroup?.title, key: "productGroup" },
            { header: RESX.ProductGroup.Ledger, render: item => item.ledgerNumber, key: "ledger" },
            { header: RESX.GeneralLabels.Description, render: item => <><div>{item.titleForTemplate}</div><div className="text-sublabel">{item.descriptionForTemplate}</div></>, key: "description" },
            { header: RESX.Financial.CostsPerUnit, className: "s1_cell_financialamount", render: item => moneyFormatter.format(item.costsPricePerUnitExVat), key: "costPerUnit" },
            { header: RESX.Financial.CostsTax, className: "s1_cell_financialamount", render: item => getVatPercentageFromId(item.costsVatRateId), key: "costsTax" },
            { header: RESX.Financial.SalesPerUnit, className: "s1_cell_financialamount", render: item => moneyFormatter.format(item.salesPricePerUnitExVat), key: "salesPerUnit" },
            { header: RESX.Financial.SalesTax, className: "s1_cell_financialamount", render: item => getVatPercentageFromId(item.salesVatRateId), key: "salesTax" },
          ]
        }}
        onDelete={(item) => window.CoreApi.ProductTemplates.Delete({ productTemplateId: item.productTemplateId })}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
          <ProductGroupFilter />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
};


export default ProductTemplateList;